/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');

    app.directive('scrollbar', [function () {
        var isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1;
        var isMac = navigator.platform.toLowerCase().indexOf('mac') !== -1;
        var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        var isIE = navigator.userAgent.toLowerCase().indexOf('trident/') !== -1;

        // console.log('scrollbar', isAndroid, isMac, iOS);
        return {
            restrict: 'A',
            link: function (scope, element, attributes) {
                if (isAndroid || isMac || iOS || isIE) {
                    return;
                }
                var native = element[0];
                Scrollbar.use(window.OverscrollPlugin);
                var scrollbar = Scrollbar.init(native, {
                    plugins: {
                        overscroll: {},
                    },
                });

                function onChange(e) {
                    // console.log('scrollbar.onChange', e.offset.y, e.limit.y, native.offsetHeight);
                    scope.$root.$broadcast('onScrollbarDidChange', {
                        offset: e.offset,
                        limit: e.limit,
                        container: {
                            width: native.offsetWidth,
                            height: native.offsetHeight,
                        }
                    });
                }
                scrollbar.addListener(onChange);
                scope.$root.$broadcast('onScrollbarInit');
                scope.$on('onScrollbarShouldScrollTo', function ($scope, options) {
                    // console.log('onScrollbarShouldScrollTo', options);
                    if (document.querySelector(options.selector) === element[0]) {
                        options.x += scrollbar.offset.x;
                        options.y += scrollbar.offset.y;
                        scrollbar.scrollTo(options.x || 0, options.y || 0, 0);
                    }
                });
            }
        };
    }]);

}());